import { FormContainer } from "@/components/form/FormContainer";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { UpdateWrapper } from "@/layouts/UpdateWrapper";
import { useOne, useResourceParams } from "@refinedev/core";
import { Button, Space, Spin } from "antd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { UpdateNodegroupSize } from "./updateNodegroupSize";
import { updateNodegroup } from "@/apis";
import { useNavigate } from "react-router-dom";

export const NodegroupEditor = () => {
  const { action, id, resource } = useResourceParams();
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const navigateBack = useNavigate();
  const { data, isLoading, isError } = useOne({
    resource: "nodegroups",
    id,
  });

  if(action === "changeNodegroup") {
    return (<UpdateNodegroupSize id={id} action={action} ></UpdateNodegroupSize>);
  }

  let rawValue = {};
  let rawSchema = [];
  if (action === 'changeAutoScaled') {
    rawSchema = [
      {
        i18nTitle: 'config.nodegroup.form.autoScaled',
        title: "Auto Scaled",
        dataIndex: "autoscaled",
        valueType: "switch",
        width: "md",
      }
    ];
    if (data) {
      rawValue = {
        id: data.id,
        autoscaled: data.autoscaled === "true" || data.autoscaled === true,
      };
    }
  } 
  const doCommit = async (values) => {
    if (action === 'changeAutoScaled') {
      const payload = {
        autoscaled: values.autoscaled ? "true" : "false",
      };
      const resp = await updateNodegroup(id, payload);
      if (resp.status === "OK") {
        if (window.history.length > 1) {
          navigateBack(-1);
        } else {
          navigate({ resource: "nodegroups", action: "list" });
        }
      } else {
        // TODO: show error message
      }
    }
  };
  return (
    <UpdateWrapper
      footer={
        <Space>
          <Button onClick={() => {
            formRef.current.submit();
            navigate({ resource: "nodegroups", action: "list" });
          }}>Cancel</Button>
          <Button type="primary" onClick={() => formRef.current.submit()}>Save</Button>
        </Space>
      }
    >
      { isLoading && <Spin /> }
      { !isLoading && <FormContainer
        formRef={formRef}
        initValue={rawValue}
        schema={rawSchema}
        onFinishCallback={doCommit}
        style={{ paddingTop: 24 }}
      /> }
    </UpdateWrapper>
  )
};